import { mapValues } from "../utils/mapValues.mjs";
import { breakpoints } from "./breakpoints.mjs";
const { mobile: _, ...breakpointsAboveMobile } = breakpoints;
const breakpointQuery = mapValues(
  breakpointsAboveMobile,
  (bp) => `screen and (min-width: ${bp}px)`
);
const makeMediaQuery = (breakpoint) => (styles) => !styles || Object.keys(styles).length === 0 ? {} : {
  [breakpointQuery[breakpoint]]: styles
};
const mediaQuery = {
  tablet: makeMediaQuery("tablet"),
  desktop: makeMediaQuery("desktop"),
  wide: makeMediaQuery("wide")
};
const responsiveStyle = ({ mobile, tablet, desktop, wide }) => ({
  ...mobile,
  ...tablet || desktop || wide ? {
    "@media": {
      ...mediaQuery.tablet(tablet ?? {}),
      ...mediaQuery.desktop(desktop ?? {}),
      ...mediaQuery.wide(wide ?? {})
    }
  } : {}
});
export {
  breakpointQuery,
  responsiveStyle
};
